import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { EditorialHero } from './components/EditorialHero';
import { RankingSection } from './components/RankingSection';
import { ClosingSection } from './components/ClosingSection';
export function App() {
  return <div className="min-h-screen" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <EditorialHero data-id="element-2" />
      <RankingSection data-id="element-3" />
      <ClosingSection data-id="element-4" />
    </div>;
}